module.exports = __FOREMAN_VENDOR__ACE_BUILDS_SRC_MIN_NOCONFLICT_EXT_SEARCHBOX__;


//////////////////
// WEBPACK FOOTER
// external "__FOREMAN_VENDOR__ACE_BUILDS_SRC_MIN_NOCONFLICT_EXT_SEARCHBOX__"
// module id = ace-builds/src-min-noconflict/ext-searchbox
// module chunks = 0